import { createPermission } from '@backstage/plugin-permission-common';

export const githubViewPermission = createPermission({
  name: 'github.integration.read',
  attributes: { action: 'read' },
});
